import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { heroBanners } from '@/mocks/comics';

export function HeroBanner() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroBanners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const banner = heroBanners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${banner.coverImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="absolute bottom-0 left-0 right-0 px-4 md:px-6 pb-12 md:pb-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50">
              {banner.tag}
            </span>
            <span className="text-background-50/70 text-xs">妖精漫画网 · 韩国漫画大全</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">
            {banner.title}
          </h1>
          <p className="text-background-50/80 text-sm md:text-base mb-6 max-w-lg">
            {banner.subtitle}
          </p>
          <Link
            to={`/comic/${banner.comicId}`}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即阅读
            <i className="ri-arrow-right-line"></i>
          </Link>

          <div className="flex items-center gap-2 mt-8">
            {heroBanners.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-8 h-1 rounded-full transition-all cursor-pointer ${
                  index === current ? 'bg-background-50 w-12' : 'bg-background-50/40'
                }`}
                aria-label={`切换到第${index + 1}张Banner`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}